
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class PixelArtLandscapeEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const pixelSize = (20 + layerIndex * 10) * (config.parallaxScale || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, pixelSize );
        const curTime = time * config.parallaxSpeed;

        ctx.fillStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.2 / (layerIndex + 1);
            for (let x = x1; x <= x2; x += pixelSize) {
                const terrainH = Math.sin(x * 0.002 + curTime) * 200 + height * 0.5;
                for (let y = y1; y <= y2; y += pixelSize) {
                    if (y > terrainH) {
                        ctx.fillRect(x, y, pixelSize * 0.9, pixelSize * 0.9);
                    }
                }
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
